import { DeliverySpeedDetail } from "./DeliverySpeed";
import { Location } from "./LocalCart";

/* eslint-disable @typescript-eslint/naming-convention */
export interface AddressNudge {
    cta_info: string;
    cta_text: string;
    cta_address_edit_text: string;
}

export interface UserAddress {
    address: string;
    address_line2: string;
    address_line_2?: string;
    annotation: string;
    area: string;
    assured: boolean;
    city: string;
    default: number;
    delivery_valid: number;
    flat_no: string;
    id: string;
    image_url: string;
    is_deleted: string;
    is_edited: string;
    landmark: string;
    lat: string;
    lng: string;
    mobile: string;
    name: string;
    rainMode: number;
    recalculation_required: boolean;
    reverse_geo_code_failed: string;
    selected: boolean;
    sort_score: number;
    user_id: string;
    sla_message: string;
    delivery_delay_message?: string;
    selected_sla_option?: string;
    delivery_type_opt_in?: boolean;
    sla_options?: DeliverySpeedDetail[];

    version?: number;
    address_id?: number;
    voice_directions_s3_uri?: string;
    alternate_mobile?: string;
    instructions?: string;
    address_nudge?: AddressNudge;
    delivery_charge_info?: string;
    is_verified?: boolean;
    created_on?: string;
    updated_on?: string;
    updated_by?: string;
    estimated_sla?: number;
    estimated_sla_min?: number;
    estimated_sla_max?: number;
    sla_bg_color?: string;
    isSelected?: boolean;
    haversineDistance?: number;

    //addes as part of address revamp, this field will denote whether address is HOME, WORK or OTHER
    addressCategory: number;
    userIntentAddressCategory?: number;
}

// Address object provided by CAS
export interface AddressEntity {
    id: string;
    version?: number;
    actual_address: {
        formatted_address?: string;
        address_line?: string;
        landmark?: string;
        address_line_2?: string;
        tags?: string[];
        contact_name?: string;
        location?: { lat?: number; lng?: number };
        address_category: number[];
        user_intent?: { address_category?: number };
    };
}

// Address object required to create address in cart address selector
export interface AddressInfo {
    address?: string;
    address_line2?: string;
    address_line_2?: string;
    annotation: string;
    flat_no?: string;
    landmark?: string;
    id: string;
    name?: string;
    lat?: string;
    lng?: string;
    rank?: number;
    isSelected?: boolean;
    haversineDistance?: number;
    cRank?: number;
    sla_message?: string;
    addressCategory: number;
    userIntentAddressCategory?: number;
}

export interface AddressApiResponse {
    addresses: AddressEntity[];
}

export enum ADDRESS_NUDGE_TOOLTIP_STATUS {
    NOT_SHOWN = -1,
    SHOW = 0,
    SHOWN = 1,
}
export interface AddressNudgePresentation {
    cart_address_nudge_threshold_distance?: number;
    cart_address_nudge_popup_duration?: number;
    cart_address_nudge_message?: string;
}
export interface AddressNudgeConfig extends AddressNudgePresentation {
    showAddressNudgeIcon: boolean;
    isAddressNudgeXpEnabled: boolean;
    addressNudgeTooltipStatus: ADDRESS_NUDGE_TOOLTIP_STATUS;
    haversineDistance?: number;
    currentLocation?: Location;
}
